export default function Testimonials() {
  const testimonials = [
    {
      quote: '每次訂購都非常新鮮，松阪豬的品質真的超棒，比超市買的好太多了！',
      name: '陳小姐',
      role: '家庭主婦',
      avatar: 'https://public.readdy.ai/ai/img_res/f4259a36b75277c458d24f866444b60e.jpg',
    },
    {
      quote: '美國肋眼牛排油花漂亮，解凍後煎出來的效果跟餐廳一樣，強烈推薦！',
      name: '林先生',
      role: '料理愛好者',
      avatar: 'https://readdy.ai/api/search-image?query=portrait%20headshot%20taiwanese%20man%20smiling%20confident%20expression%20neutral%20background%20high%20quality%20photography&width=100&height=100&seq=rev002&orientation=squarish',
    },
    {
      quote: '包裝很用心，真空包裝保鮮效果好，客服也很親切，下次還會再訂！',
      name: '王媽媽',
      role: '忠實顧客',
      avatar: 'https://readdy.ai/api/search-image?query=portrait%20headshot%20middle%20aged%20taiwanese%20woman%20warm%20smile%20friendly%20expression%20neutral%20background%20high%20quality%20photography&width=100&height=100&seq=rev003&orientation=squarish',
    },
  ];

  return (
    <section className="py-20 bg-[#1a1a1a]">
      <div className="px-6 lg:px-16">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4A96A] mb-3 font-medium">顧客評價</p>
          <h3 className="text-4xl font-black text-white tracking-tight">顧客怎麼說</h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#242424] rounded-2xl p-7">
              <div className="flex mb-4">
                {[...Array(5)].map((_, s) => (
                  <span key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#D4A96A] text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-white/80 text-sm leading-relaxed mb-6">「{t.quote}」</p>
              <div className="flex items-center space-x-3">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <p className="text-white font-bold text-sm">{t.name}</p>
                  <p className="text-white/40 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
